import i18n from '@/plugins/i18n';
const integrations = {
  key: 'integrations',
  name: i18n.global.t('integrations'),
  icon: 'integrations',
};
export default integrations;
